module.exports = __webpack_public_path__ + "img/f6627ac.png";